<section [ngClass]="{'custom-bg': showExistingFields && listFields.length > 0}">
    <div class="header d-flex justify-content-between mb-4 border-bottom pb-3 px-3 py-2">
        <div>
            <div class="font18 font500 mb-1">{{this.data.create ? 'Custom Form' : 'Edit Form'}}</div>
            <div class="font14 text-secondary">Add a personalized form to collect exactly the information you need.</div>
        </div>
        <div class="close text-secondary cursor-pointer" (click)="closeDialog()"> <mat-icon>close</mat-icon> </div>
    </div>

    <div class="body-part m-auto">
        <div class="form-part px-3 py-2" (click)="saveTitle()">
    
            <div class="text-center w-100 mb-4">
                <!-- DISPLAY MODE -->
                <div class="title" [ngClass]="{'title-border': !formTitle}" *ngIf="!addTitle"
                    (click)="openTitleEdit($event)">
    
                    {{ formTitle || 'Add title' }}
                </div>
                <!-- EDIT MODE -->
                <input *ngIf="addTitle" type="text" [(ngModel)]="formTitle" placeholder="Add title"
                    class="form-control font14 bg-gray py-2" (click)="$event.stopPropagation()" (blur)="saveTitle()"
                    autofocus />
            </div>

            <div class="d-flex gap-4">
                <div class="mb-3 w-100">
                    <label class="font14 font500 mb-1">
                        Name <span class="text-danger">*</span>
                    </label>
                    <input type="text" disabled placeholder="Enter your name" [(ngModel)]="name" class="form-control font14 bg-gray py-2">
                </div>

                <div class="mb-3 w-100">
                    <label class="font14 font500 mb-1">
                        Mobile Number <span class="text-danger">*</span>
                    </label>
                    <input type="number" disabled placeholder="Enter your whatsapp mobile number" [(ngModel)]="mobile" class="form-control font14 bg-gray py-2">
                </div>
            </div>

            <div class="mb-3">
                <label class="font14 font500 mb-1">
                    Email
                </label>
                <input type="text" disabled placeholder="Enter your email" [(ngModel)]="email" class="form-control font14 bg-gray py-2">
            </div>

            <div class="custom-fields">
                <div *ngFor="let field of listFields">
                    <div class="text-field mb-3 w-100"
                        *ngIf="field.dataType === 'TEXT' || field.dataType === 'MONEY'">
                        <label class="font14 font500 mb-1">
                            {{field.fieldLabel}} <span *ngIf="field.required" class="text-danger">*</span>
                        </label>
                        <input type="text" disabled [placeholder]="field.hint ? field.hint : 'Enter here'"
                            class="form-control font14 bg-gray py-2">
                    </div>

                    <div class="text-field mb-3 w-100"
                        *ngIf="field.dataType === 'NUMBER'">
                        <label class="font14 font500 mb-1">
                            {{field.fieldLabel}} <span *ngIf="field.required" class="text-danger">*</span>
                        </label>
                        <input type="number" disabled [placeholder]="field.hint ? field.hint : 'Enter here'"
                            class="form-control font14 bg-gray py-2">
                    </div>

                    <div class="text-field mb-3 w-100" *ngIf="field.dataType === 'DESC'">
                        <label class="font14 font500 mb-1">
                            {{field.fieldLabel}} <span *ngIf="field.required" class="text-danger">*</span>
                        </label>
                        <textarea disabled name="" id="" cols="30" rows="4" [placeholder]="field.hint ? field.hint : 'Enter description here'" 
                            class="form-control font14 bg-gray py-2"></textarea>
                    </div>

                    <div class="text-field mb-3 w-100" *ngIf="field.dataType === 'DATE'">
                        <div class="font14 font500 mb-1">
                            {{field.fieldLabel}} <span *ngIf="field.required" class="text-danger">*</span>
                        </div>
                        <mat-form-field class="full-width date-input" appearance="outline">
                            <input matInput class="inputStyle" [matDatepicker]="picker" [placeholder]="field.hint ? field.hint : 'Select date'"
                                readonly>
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="text-field mb-3 w-100" *ngIf="field.dataType === 'DROPDOWN'">
                        <div class="font14 font500 mb-1">
                            {{field.fieldLabel}} <span *ngIf="field.required" class="text-danger">*</span>
                        </div>
                        <mat-form-field class="full-width date-input" appearance="outline">
                            <mat-select class="inputStyle" [placeholder]="field.hint ? field.hint : 'Select option'" >
                                <mat-option *ngFor="let option of field.value" [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="text-field mb-3 w-100" *ngIf="field.dataType === 'CHECKBOX'">
                        <div class="font14 font500 mb-1">
                            {{ field.fieldLabel }} <span *ngIf="field.required" class="text-danger">*</span>
                        </div>
                        <div class="options" [class.long-options]="hasLongOption(field.value)">
                            <div class="list-inputs text-nowrap" *ngFor="let option of field.value; let i = index">
                                <input type="checkbox" [id]="field.fieldLabel + i" [value]="option.value" class="me-2" />
                                <label [for]="field.fieldLabel + i">{{ option.label }}</label>
                            </div>
                        </div>
                    </div>

                    <div class="text-field mb-3 w-100" *ngIf="field.dataType === 'RADIOBUTTON'">
                        <div class="font14 font500 mb-1">
                            {{ field.fieldLabel }} <span *ngIf="field.required" class="text-danger">*</span>
                        </div>
                        <div class="options" [class.long-options]="hasLongOption(field.value)">
                            <div class="list-inputs text-nowrap d-flex align-items-center" *ngFor="let option of field.value; let i = index">
                            <input type="radio" [id]="field.fieldLabel + i" [name]="field.fieldLabel"
                                [value]="option.value" class="px-2 me-2 mt-1" />
                            <div>{{ option.label }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="text-field mb-3 w-100" *ngIf="field.dataType === 'RATING'">
                        <div class="font14 font500 mb-1">
                            {{ field.fieldLabel }} <span *ngIf="field.required" class="text-danger">*</span>
                        </div>
                        <div class="d-flex align-items-center gap-2 mb-3">
                            <span *ngFor="let s of [1,2,3,4,5]" class="star d-flex align-items-center cursor-pointer gap-1" [class.active]="s <= rating" (click)="setRating(s)">
                                <mat-icon>star</mat-icon>
                            </span>
                        </div>
                    </div>

                </div>
            </div>

        </div>
        <div class="btn-section align-items-center w-100 d-flex justify-content-between border-top py-2 px-2">
            <div class="d-flex gap-2">
                <div class="configure-btn font14 font500 d-flex justify-content-start cursor-pointer" (click)="configureFields()">
                    Add fields
                </div>
                <div *ngIf="this.listFields.length > 0 " class="configure-btn font14 font500 d-flex justify-content-start cursor-pointer" (click)="showExistingFields = true">
                    Edit fields
                </div>
                </div>

            <button [disabled]="btnLoader || !formTitle" (click)="createForm()"
                class="save text-light d-flex gap-2 rounded-2 border-0 w-auto">
                <span class="font16">{{btnLoader ? 'Saving...' : 'Save'}}</span>
            </button>
        </div>
    </div>

    <div class="offcanvas-body" *ngIf="showExistingFields && listFields.length > 0">
        <div class="heading d-flex justify-content-between mb-3">
            <div class="font18 font500">Edit existing fields</div>
            <div class="close text-secondary cursor-pointer" (click)="closeEdit()">
                <mat-icon>close</mat-icon> 
            </div>
        </div>
        <div class="field-editor">
            <div *ngFor="let field of listFields; let i = index" class="border rounded mb-3 p-2">
        
                <!-- Header -->
                <div class="d-flex justify-content-between align-items-center cursor-pointer" (click)="toggleField(i)">
                    <label class="font16 font500 mb-0 text-nowrap">
                        {{ field?.dataType | titlecase }}
                    </label>
                    <div class="d-flex align-items-center gap-2">
                        <mat-icon class="text-danger" (click)="deleteField(i); $event.stopPropagation()"> delete </mat-icon>
                        <mat-icon> {{ activeIndex === i ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </div>
                </div>
        
                <!-- Collapsible Content -->
                <div *ngIf="activeIndex === i" class="mt-2">
        
                    <div class="mb-2">
                        <label class="font14 font500 mb-1">Field label</label>
                        <input class="form-control font14 bg-gray py-2" [(ngModel)]="field.fieldLabel"
                            placeholder="Field label" />
                    </div>
        
                    <div class="mb-2">
                        <label class="font14 font500 mb-1">Field hint</label>
                        <input class="form-control font14 bg-gray py-2" [(ngModel)]="field.hint" placeholder="Field hint" />
                    </div>
        
                    <!-- Options -->
                    <div *ngIf="field.dataType === 'DROPDOWN' || field.dataType === 'CHECKBOX' || field.dataType === 'RADIOBUTTON'">
                        <div class="font16 mb-1">Options</div>
                        <div class="edit-options gap-2">
                            <div *ngFor="let opt of field.value; let j = index">
                                <div class="d-flex gap-1 mb-1 align-items-center">
                                    <input class="form-control font14 bg-gray py-2" [(ngModel)]="opt.label"
                                        placeholder="Option label" (keydown.enter)="addOption(i)">
        
                                    <button [disabled]="field.value.length <= 2" class="btn btn-sm w-auto p-0 border-0" (click)="removeOption(i,j)">
        
                                        <mat-icon class="text-danger">close</mat-icon>
                                    </button>
                                </div>
                                <div class="font12 text-danger" *ngIf="opt.label.length === 0">
                                    Field can not be empty
                                </div>
                            </div>
                            <div class="font12 text-danger" *ngIf="hasDuplicateOptions(field.value)">
                                Field values can not be same
                            </div>
                        </div>
                        <div class="mt-2">
                            <span (click)="addOption(i)" class="btn btn-sm add-btn px-1 py-1">+ Add option</span>
                        </div>
                    </div>
        
                    <div class="my-2 d-flex gap-2 align-items-center">
        
                        <div class="d-flex gap-1 align-items-center">
                            <input type="checkbox" class="form-check-input mt-0" [(ngModel)]="field.required">
                            <label class="font12">Mark as required</label>
                        </div>
        
                        <div class="d-flex gap-1 align-items-center">
                            <input type="checkbox" class="form-check-input mt-0" [(ngModel)]="field.filterable">
                            <label class="font12">Mark as filterable</label>
                        </div>
        
                        <div class="d-flex gap-1 align-items-center">
                            <input type="checkbox" class="form-check-input mt-0" [(ngModel)]="field.searchable">
                            <label class="font12">Mark as searchable</label>
                        </div>
        
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end cursor-pointer w-100"
            (click)="configureFields('addMore')">
            <span class="configure-btn font14 font500">+ Add New Fields</span>
        </div>
    </div>
</section>